// src/utils/csvParser.js
import Papa from 'papaparse';

const DEFAULT_COLUMN_MAPPING = [
  'title',         // Nombre del recurso/material
  'description',   // Una breve descripción (hasta 65 palabras aprox)
  'link',          // Link
  'tipo',          // Tipo de recurso
  'tema',          // Tema
  'organizacion',  // Organización autora del recurso/material
  'pais',          // País
  'year',          // Año de publicación
  'img_link',      // Agregar imagen de portada y/o fotos
];

const fetchCSV = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const reader = response.body.getReader();
  const result = await reader.read();
  const decoder = new TextDecoder('utf-8');
  return decoder.decode(result.value);
};

const parseCSVData = (csv, columnMapping) => {
  return new Promise((resolve, reject) => {
    Papa.parse(csv, {
      complete: (results) => {
        const parsedData = results.data.slice(1).map((row, index) => {
          const mappedRow = { id: String(index) };
          columnMapping.forEach((key, i) => {
            if (key) {
              let value = row[i] || '';
              
              // Procesar campos que pueden tener múltiples valores separados por comas
              if (key === 'tipo' || key === 'tema') {
                if (value.trim()) {
                  // Dividir por comas, limpiar espacios y filtrar vacíos
                  value = value.split(',')
                    .map(item => item.trim())
                    .filter(item => item.length > 0);
                } else {
                  value = [];
                }
              }
              
              mappedRow[key] = value;
            }
          });
          return mappedRow;
        });
        console.log(parsedData);
        resolve(parsedData);
      },
      error: (error) => reject(new Error(`CSV parsing error: ${error.message}`)),
    });
  });
};

export const parseCSV = async (url, columnMapping = DEFAULT_COLUMN_MAPPING) => {
  try {
    const csv = await fetchCSV(url);
    return await parseCSVData(csv, columnMapping);
  } catch (error) {
    console.error('Error in parseCSV:', error);
    throw error;
  }
};